import { render, staticRenderFns } from "./settle_product.vue?vue&type=template&id=1603f10b&scoped=true"
import script from "./settle_product.vue?vue&type=script&lang=js"
export * from "./settle_product.vue?vue&type=script&lang=js"
import style0 from "./settle_product.vue?vue&type=style&index=0&id=1603f10b&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1603f10b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins/workspace/web-page/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1603f10b')) {
      api.createRecord('1603f10b', component.options)
    } else {
      api.reload('1603f10b', component.options)
    }
    module.hot.accept("./settle_product.vue?vue&type=template&id=1603f10b&scoped=true", function () {
      api.rerender('1603f10b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "found/views/dms/views/order_manage/order_manage/form/components/settle_product.vue"
export default component.exports